import axiosInstance from "../api/axios";
import { createContext, useMemo } from "react";

export let DashboardContext = createContext();

function getUsers(page, limit, filters = {}) {
    return axiosInstance.get('/getusers', {
        params: {
            page,
            limit,
            ...filters // Pass additional filters like tagId, breed, etc.
        }
    })
    .then((response) => response)
    .catch((err) => err);
}


export default function DashboardContextContextProvider(props) {
    const contextValue = useMemo(
        () => ({ getUsers }),
        []
    );

    return <DashboardContext.Provider value={contextValue}>
        {props.children}
    </DashboardContext.Provider>;
}
